import MobileLayout from "../components/MobileLayout";
import Header from "../components/Header";
import BottomNavigation from "../components/BottomNavigation";

function AppLayout({

    title,

    subTitle,

    right,

    children

}) {

    return (

        <>

            <MobileLayout>

                <Header

                    title={title}

                    subTitle={subTitle}

                    right={right}

                />

                {children}

            </MobileLayout>

            <BottomNavigation />

        </>

    );

}

export default AppLayout;